module.exports = __webpack_public_path__ + "logo-85193773ce95835fc9530144105f63b6.png";